exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sticky-col{position:-webkit-sticky;position:sticky}.grade-cor,.sticky-col{background-color:#fff;left:0}.grade-cor{height:40px;padding:10px;width:200px;border-bottom:1px solid #e0e0e0;-webkit-box-shadow:3px 0 10px -4px #d3cdcd;-moz-box-shadow:3px 0 10px -4px #d3cdcd;box-shadow:3px 0 10px -4px #d3cdcd}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-39db60c6","scoped":false,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/grade.vue
// module id = 1423
// module chunks = 0